exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fa-exclamation-circle[data-v-ea8940fa]{color:#ffc72c;font-size:80px}p[data-v-ea8940fa]:last-child{margin-bottom:0}", ""]);

// exports
